import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 3h18a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-9l-6 5v-5H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }